/**
 * All messages are listed here
 */
import React, { Component } from "react";
import { ReduxDispatch, ReduxState } from "../../ducks/reducers";
import { connect } from "react-redux";

import Paper from "material-ui/Paper";
import {
    Grid,
    withStyles,
    WithStyles,
    Theme,
    Tooltip,
    Button,
    List,
    ListItemText,
    ListItem,
    ListItemIcon,
    Divider,
} from "material-ui";
import Avatar from "material-ui/Avatar";
import Add from "material-ui-icons/Add";
import PriorityHigh from "material-ui-icons/PriorityHigh";
import Email from "material-ui-icons/Email";
import Drafts from "material-ui-icons/Drafts";
import { SetHeader, SetBottomBarTab } from "../../ducks/common";
import { IThreadRow } from "../../util/interfaces";
import moment from "moment";
import { RouteProps, RouterProps } from "react-router";
import FullPageSpinner from "components/FullPageSpinner/FullPageSpinner";
import { MessagesTab } from "components/BottomBar/BottomBar";
import {
    getMessageThreads,
    getThreads,
    messagesLoading,
} from "../../ducks/messages";
import {
    MessageThreadDto,
    MessageStatus,
    MessageSender,
} from "../../util/DTOs/MessageDtos";

const styles = (theme: Theme) =>
    ({
        fab: {
            margin: theme.spacing.unit * 2,
        },
        customFab: {
            backgroundColor: "#92c9f0",
            color: "#FFF",
            zIndex: 1,
        },
        absolute: {
            position: "fixed",
            bottom: theme.spacing.unit * 8,
            right: theme.spacing.unit * 1,
        },
        msgAvatar: {
            backgroundColor: "#FFF",
            color: "#808080",
        },
        priorityAvatar: {
            backgroundColor: "#FFF",
            color: "#ec6608",
        },
    } as React.CSSProperties);

interface IThreadsProps {}

interface IThreadsState {
    threadDialogOpen: boolean;
}

interface IThreadsPageDispatchProps {
    setHeader: (value: string) => void;
    fetchThreads: () => void;
    setBottomBarTab: (tab?: number) => void;
}

interface IThreadsPageReduxProps {
    threads: IThreadRow[];
    loading: boolean;
}

type ThreadsPropsWithStyles = IThreadsProps &
    WithStyles<
        "fab" | "absolute" | "customFab" | "msgAvatar" | "priorityAvatar"
    > &
    IThreadsPageDispatchProps &
    IThreadsPageReduxProps &
    RouterProps &
    RouteProps;

class ThreadsPage extends React.Component<
    ThreadsPropsWithStyles,
    IThreadsState
> {
    constructor(props: ThreadsPropsWithStyles) {
        super(props);

        this.state = {
            threadDialogOpen: false,
        };
    }

    componentDidMount() {
        this.props.setHeader("Viestit");
        this.props.fetchThreads();
        this.props.setBottomBarTab(MessagesTab);
    }

    componentWillUnmount() {
        this.props.setHeader("");
        this.props.setBottomBarTab();
    }

    openNewThreadPage = () => {
        this.props.history.push("/messages/new-thread");
    };

    renderThreadRows = (threads: IThreadRow[]): JSX.Element => {
        let items: JSX.Element[] = [];
        threads.forEach((item: IThreadRow) => {
            const timeStr = `${moment(item.time).format("D.M.YYYY - H:mm")}`;

            items.push(
                <ListItem
                    className="hypo-newsfeed-item gridItem"
                    style={{ alignItems: "initial" }}
                    key={item.id}
                    tabIndex={0}
                    onClick={() => {
                        this.props.history.push(`/messages/${item.id}`);
                    }}
                    onKeyDown={(event) => {
                        if (event.key === "Enter") {
                            this.props.history.push(`/messages/${item.id}`);
                        }
                    }}
                >
                    <Avatar className={this.props.classes.msgAvatar}>
                        {(item.new && (
                            <Email style={{ color: "#ec6608" }} />
                        )) || <Drafts />}
                    </Avatar>
                    <ListItemText
                        classes={{ primary: "hypoblue" }}
                        primary={item.header}
                        secondary={timeStr}
                    />
                    {item.priority && (
                        <Avatar className={this.props.classes.priorityAvatar}>
                            <PriorityHigh />
                        </Avatar>
                    )}
                </ListItem>
            );

            items.push(
                <Divider key={item.id + "-divider"} inset component="li" />
            );
        });

        if (items.length > 0) {
            items.pop();
        }

        return <List>{items}</List>;
    };

    render() {
        const { classes } = this.props;
        const showSpinner =
            this.props.loading &&
            (!this.props.threads || this.props.threads.length === 0);

        return (
            <div>
                <FullPageSpinner loading={showSpinner} />
                <Grid
                    container
                    direction={"row"}
                    justify={"center"}
                    alignItems={"center"}
                    spacing={0}
                >
                    <Grid item xs={12} md={8}>
                        <Tooltip title="Uusi viesti">
                            <Button
                                title="Uusi viesti"
                                variant="fab"
                                color="default"
                                className={`${this.props.classes.absolute} ${this.props.classes.customFab}`}
                                onClick={this.openNewThreadPage}
                            >
                                <Add />
                            </Button>
                        </Tooltip>
                    </Grid>
                    {(!this.props.threads ||
                        this.props.threads.length === 0) && (
                        <div className="centered-message-container">
                            <h2 className="hypodgrey">EI VIESTEJÄ</h2>
                        </div>
                    )}
                    <Grid item xs={12} md={8}>
                        {this.renderThreadRows(this.props.threads)}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): IThreadsPageReduxProps => {
    const threadsFromState = getThreads(state);
    const loading = messagesLoading(state);

    const threads = Object.keys(threadsFromState).map((key) => {
        const thread = threadsFromState[key] as MessageThreadDto;
        return {
            id: thread.id,
            time: thread.createdAt,
            sender: "TODO",
            header: thread.title,
            priority: false,
            new: thread.messages.some(
                (x) =>
                    x.status === MessageStatus.New &&
                    x.sender !== MessageSender.Customer
            ),
        } as IThreadRow;
    });

    return {
        threads: threads.sort((a, b) => {
            return a.time < b.time ? 1 : -1;
        }),
        loading: loading,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IThreadsPageDispatchProps => {
    return {
        setHeader: (value: string) => {
            dispatch(SetHeader(value));
        },
        fetchThreads: () => {
            dispatch(getMessageThreads());
        },
        setBottomBarTab: (tab?: number) => {
            dispatch(SetBottomBarTab(tab));
        },
    };
};

export default connect<IThreadsPageReduxProps, IThreadsPageDispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)<ThreadsPropsWithStyles>(ThreadsPage));



// WEBPACK FOOTER //
// ./src/views/messages/ThreadsPage.tsx